<img *ngIf="state.logo" class="status-logo mr-1" [src]="state.logo" [alt]="state.text" />
<span class="fs-07">{{ state.text }}</span>
